import { addToChainAfter, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { AddStockedItemsFilter, chain, DispatchSetProductFilters } from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { CustomHandlerWithResult } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { ProductFiltersExtended } from "@WhiteCap/Store/Reducer/WhiteCapReducer/ProductListIsStockAvailableReducer";

type HandlerType = CustomHandlerWithResult<ProductFiltersExtended, ProductFiltersExtended>;

export const AddStockedAtBranchFilter: HandlerType = props => {
    if (props.parameter.isInStockAtBranch !== undefined) {
        props.result.isInStockAtBranch = props.parameter.isInStockAtBranch;
    }
};

export const DispatchIsInStockFilter: HandlerType = props => {
    props.dispatch({
        type: "Custom/ProductList/IsStockAvailable/SetIsInStockAtBranch",
        data: props.result,
    });
};

addToChainAfter(
    chain as HandlerWithResult<ProductFiltersExtended, ProductFiltersExtended>[],
    AddStockedItemsFilter,
    AddStockedAtBranchFilter as HandlerWithResult<ProductFiltersExtended, ProductFiltersExtended>
);

addToChainAfter(
    chain as HandlerWithResult<ProductFiltersExtended, ProductFiltersExtended>[],
    DispatchSetProductFilters,
    DispatchIsInStockFilter as HandlerWithResult<ProductFiltersExtended, ProductFiltersExtended>
);